import { useTranslate } from "ra-core";
import { useMemo } from "react";

import { useConfigurationContext } from "../root/ConfigurationContext";
import type { LabeledValue, PartnerCategory } from "../types";

export const PARTNER_CATEGORIES: PartnerCategory[] = ["staff", "partner"];

/**
 * Types set in the Settings for a category: staff types or partner types.
 * Without a category, both lists.
 */
export const usePartnerTypes = (
  category?: PartnerCategory | null,
): LabeledValue[] => {
  const { staffTypes, partnerTypes } = useConfigurationContext();
  return useMemo(() => {
    if (category === "staff") return staffTypes;
    if (category === "partner") return partnerTypes;
    return [...staffTypes, ...partnerTypes];
  }, [category, staffTypes, partnerTypes]);
};

/** « Staff » and « Partenaire », for inputs and filters. */
export const usePartnerCategoryChoices = (): LabeledValue[] => {
  const translate = useTranslate();
  return PARTNER_CATEGORIES.map((value) => ({
    value,
    label: translate(`resources.partners.categories.${value}`),
  }));
};

export const findTypeLabel = (
  types: LabeledValue[],
  value?: string | null,
): string => types.find((type) => type.value === value)?.label ?? value ?? "";
